import { render, staticRenderFns } from "./Collapse.vue?vue&type=template&id=6eccfc80&scoped=true&"
import script from "./Collapse.vue?vue&type=script&lang=ts&"
export * from "./Collapse.vue?vue&type=script&lang=ts&"
import style0 from "./Collapse.vue?vue&type=style&index=0&id=6eccfc80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eccfc80",
  null
  
)

export default component.exports